export const ResponsibleGamingEnum = {
    DepositLimitSection: 0,
    BetLimitSection: 1,
    LossLimitSection: 2,
    RealityCheckSection: 3,
    AccessLimitSection: 4,
    TimeLimitSection: 5,
    SelfExclusionSection: 6,
    NsepSection: 7,
    TimeOutSection: 8,
    AccountClosureSection: 9 
}

export const ResponsibleGamingTabs = {
    'depositLimitSection': {val:'depositLimit',key:ResponsibleGamingEnum.DepositLimitSection},
    'betLimitSection': {val:'betLimit',key:ResponsibleGamingEnum.BetLimitSection},
    'lossLimitSection': {val:'lossLimit',key:ResponsibleGamingEnum.LossLimitSection},
    'realityCheckSection': {val:'realityCheck',key:ResponsibleGamingEnum.RealityCheckSection},
    'accessLimitSection': {val:'accessLimit',key:ResponsibleGamingEnum.AccessLimitSection},
    'rngTimeLimitSection': {val:'timeLimit',key:ResponsibleGamingEnum.TimeLimitSection},    
    'selfExclusionSection': {val:'selfExclusion',key:ResponsibleGamingEnum.SelfExclusionSection},
    'nsepSection': {val:'nsep',key:ResponsibleGamingEnum.NsepSection},
    'timeOutSection': {val:'timeout',key:ResponsibleGamingEnum.TimeOutSection},
    'accountClosureSection': {val:'accountClosure',key:ResponsibleGamingEnum.AccountClosureSection}
}

Object.freeze(ResponsibleGamingEnum);

export default ResponsibleGamingEnum;